module.exports = __webpack_public_path__ + "img/21.8ac2d01f.jpg";